<template>
  <ProprietaireConnect />
</template>

<script>
  import ProprietaireConnect from "@/components/ProprietaireConnect.vue";
  export default {
    name: "ProductListPage",
    components: {
      ProprietaireConnect,
    },
    data() {
      return {};
    },
    computed: {},
    mounted() {},
    methods: {},
  };
</script>
